import React from "react";
import { Link } from "react-router-dom";
import { MountainSnowIcon } from "lucide-react";
type LogoProps = {
  tone?: "light" | "dark";
};
export function Logo({
  tone = "dark"
}: LogoProps) {
  const isLight = tone === "light";
  return <Link to="/" className="flex items-center gap-3 rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-clay" aria-label="MANY Loisirs — accueil" data-id="element-137" data-mp="3qb5tmirzibhl">
      <span className={`flex h-10 w-10 items-center justify-center rounded-full border-2 transition-colors duration-200 ${isLight ? "border-white text-white" : "border-ink text-ink"}`} data-id="element-138" data-mp="msl0cixnru8n">
        <MountainSnowIcon className="h-5 w-5" strokeWidth={2} aria-hidden="true" data-id="element-139" data-mp="dreia5fd2bda" />
      </span>
      <span className="flex flex-col leading-none" data-id="element-140" data-mp="hsgfyhtmqfd5">
        <span className={`font-display text-xl font-semibold tracking-tight transition-colors duration-200 ${isLight ? "text-white" : "text-ink"}`} data-id="element-141" data-mp="2yif04g1or0w1">
          MANY
        </span>
        <span className={`text-[11px] font-medium transition-colors duration-200 ${isLight ? "text-white/80" : "text-muted"}`} data-id="element-142" data-mp="32hw5zal0y01q">
          Loisirs · Pays Basque
        </span>
      </span>
    </Link>;
}